<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มประเภทการลา</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ leaveRightInit.leave_type_code }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ leaveRightInit.title_th }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          รหัสประเภทการลา
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="leaveType.leave_type_code"
          :rules="[
            (v) => !!v || 'โปรดระบุรหัสประเภทการลา',
            (v) =>
              (v && v.length >= 1 && v.length <= 32) ||
              'รหัสประเภทการลาต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'leave_type_code')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ประเภทการลา (ไทย)
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="leaveType.title_th"
          :rules="[
            (v) => !!v || 'โปรดระบุชื่อประเภทการลา',
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'ชื่อประเภทการลาต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">ประเภทการลา (อังกฤษ)</label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="leaveType.title_en"
          :rules="[
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'ชื่อประเภทการลาต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        ></v-text-field>
        <div>
          <label class="body-2">
            สิทธิการลา <span class="red--text"><strong>*</strong></span>
          </label>
          <div class="d-flex align-center">
            <div class="flex-grow-1">
              <v-text-field
                v-model.number="leaveRight.day_rights"
                type="number"
                label="วัน"
                min="0"
                max="365"
                class="fix-google-chrome mt-1"
                :rules="[
                  (v) => (v !== null && v !== '') || 'กรุณาใส่ค่า',
                  (v) => /^\d+$/.test(v) || 'กรุณาใส่เฉพาะตัวเลข',
                  (v) => (v >= 0 && v <= 365) || 'กรุณาใส่ค่า 0-365',
                ]"
                tabindex="4"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="flex-grow-1 ml-2">
              <v-text-field
                v-model.number="leaveRight.hour_rights"
                type="number"
                label="ชั่วโมง"
                min="0"
                max="23"
                class="fix-google-chrome mt-1"
                :rules="[
                  (v) => (v !== null && v !== '') || 'กรุณาใส่ค่า',
                  (v) => /^\d+$/.test(v) || 'กรุณาใส่เฉพาะตัวเลข',
                  (v) => (v >= 0 && v <= 23) || 'กรุณาใส่ค่า 0-23',
                ]"
                tabindex="5"
                outlined
                dense
              ></v-text-field>
            </div>
          </div>
        </div>
        <label class="body-2">
          การนับวันลา <span class="red--text"><strong>*</strong></span>
        </label>
        <v-select
          class="fix-google-chrome mt-1"
          tabindex="6"
          v-model="leaveType.is_include_days_off"
          :items="[
            { text: 'นับรวมวันหยุด', value: true },
            { text: 'ไม่นับรวมวันหยุด', value: false },
          ]"
          :rules="[(v) => !!v || v === false || 'โปรดระบุการนับวันลา']"
          required
          item-text="text"
          item-value="value"
          outlined
          dense
        ></v-select>
        <label class="body-2">
          สิทธิ์การลาตามเพศ <span class="red--text"><strong>*</strong></span>
        </label>
        <v-select
          class="fix-google-chrome mt-1"
          tabindex="7"
          v-model="leaveType.gender_leave_type"
          :items="[
            { text: 'เพศชาย', value: 'male' },
            { text: 'เพศหญิง', value: 'female' },
            { text: 'เพศชาย และ เพศหญิง', value: 'male_and_female' },
          ]"
          :rules="[(v) => !!v || v === false || 'โปรดระบุสิทธิ์การลาตามเพศ']"
          required
          item-text="text"
          item-value="value"
          outlined
          dense
        ></v-select>
        <v-checkbox
          v-model="leaveType.leave_type"
          tabindex="8"
          label="คำนวณวันลาตามอายุงาน"
          dense
        >
          <template v-slot:label>
            <span class="body-2">คำนวณวันลาตามอายุงาน</span>
          </template>
        </v-checkbox>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="
            !isLeaveTypeDataChange &&
            !isCompanyLeaveRightDataChange &&
            formAction === 'edit'
          "
        >
          <v-btn
            :disabled="
              uiCtrl &&
              !uiCtrl.isEnable('btn:::leave:leave_rights:company:delete')
            "
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="
              uiCtrl &&
              !uiCtrl.isEnable('btn:::leave:leave_rights:company:create')
            "
            tabindex="9"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="
              uiCtrl &&
              !uiCtrl.isEnable('btn:::leave:leave_rights:company:update')
            "
            tabindex="9"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    leaveRight: {
      type: Object,
    },
    leaveRightInit: {
      type: Object,
    },
    leaveType: {
      type: Object,
    },
    leaveTypeInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isLeaveTypeDataChange() {
      if (
        this.leaveType.leave_type_code !== this.leaveTypeInit.leave_type_code ||
        this.leaveType.title_th !== this.leaveTypeInit.title_th ||
        this.leaveType.title_en !== this.leaveTypeInit.title_en ||
        this.leaveType.gender_leave_type !==
          this.leaveTypeInit.gender_leave_type ||
        this.leaveType.is_include_days_off !==
          this.leaveTypeInit.is_include_days_off ||
        this.leaveType.leave_type !== this.leaveTypeInit.leave_type
      ) {
        this.$emit('isLeaveTypeDataChange', true)
        return true
      }
      this.$emit('isLeaveTypeDataChange', false)
      return false
    },
    isCompanyLeaveRightDataChange() {
      if (
        this.leaveRight.day_rights !== this.leaveRightInit.day_rights ||
        this.leaveRight.hour_rights !== this.leaveRightInit.hour_rights
      ) {
        this.$emit('isCompanyLeaveRightDataChange', true)
        return true
      }
      this.$emit('isCompanyLeaveRightDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      addLeaveType: 'leaveType/addLeaveType',
      editLeaveType: 'leaveType/editLeaveType',
      deleteLeaveType: 'leaveType/deleteLeaveType',
      editCompanyLeaveRight: 'companyLeaveRight/editCompanyLeaveRight',
    }),
    checkEmpty(value, field) {
      if (value) {
        this.leaveType[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบประเภทการลา',
        value: this.leaveType.title_th,
        item: this.leaveType,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    async submitConfirmDialogDelete(leaveType) {
      try {
        this.confirmDialogDeleteLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        await this.deleteLeaveType({
          company_uuid,
          leave_type_uuid: leaveType.leave_type_uuid,
        })

        this.confirmDialogDeleteLoading = false
        this.confirmDialogDelete = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        this.$refs.form.resetValidation()
        this.$emit('formActionCompleted', this.formAction)
      } catch (error) {
        this.confirmDialogDeleteLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            body: {
              leave_type_code: this.leaveType.leave_type_code,
              title_th: this.leaveType.title_th,
              title_en: this.leaveType.title_en || null,
              date_after_leave: 1,
              date_before_leave: 1,
              is_male: ['male', 'male_and_female'].includes(
                this.leaveType.gender_leave_type
              ),
              is_female: ['female', 'male_and_female'].includes(
                this.leaveType.gender_leave_type
              ),
              leave_type: this.leaveType.leave_type ? 'annual' : null,
              is_include_days_off: this.leaveType.is_include_days_off,
              year_period: this.leaveType.year_period + '',
              day_rights: this.leaveRight.day_rights,
              hour_rights: this.leaveRight.hour_rights,
            },
          }

          await this.addLeaveType(payload)

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const apiPutList = []

          const leaveType = {
            leave_type_code: this.leaveType.leave_type_code,
            title_th: this.leaveType.title_th,
            title_en: this.leaveType.title_en || null,
            date_after_leave: 1,
            date_before_leave: 1,
            is_male: ['male', 'male_and_female'].includes(
              this.leaveType.gender_leave_type
            ),
            is_female: ['female', 'male_and_female'].includes(
              this.leaveType.gender_leave_type
            ),
            leave_type: this.leaveType.leave_type ? 'annual' : null,
            is_include_days_off: this.leaveType.is_include_days_off,
            year_period: this.leaveType.year_period + '',
            day_rights: this.leaveRight.day_rights,
            hour_rights: this.leaveRight.hour_rights,
          }

          if (this.isLeaveTypeDataChange) {
            apiPutList.push(
              this.editLeaveType({
                company_uuid,
                leave_type_uuid: this.leaveType.leave_type_uuid,
                body: leaveType,
              })
            )
          }

          if (this.isCompanyLeaveRightDataChange) {
            apiPutList.push(
              this.editCompanyLeaveRight({
                company_uuid,
                leave_right_uuid: this.leaveRight.leave_rights_uuid,
                data: {
                  day_rights: this.leaveRight.day_rights,
                  hour_rights: this.leaveRight.hour_rights,
                },
              })
            )
          }

          await Promise.all([...apiPutList])

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    onClose() {
      if (this.isCompanyLeaveRightDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        this.$emit('formActionCompleted', 'close')
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs.form.resetValidation()
      this.$emit('formActionCompleted', this.formAction)
    },
    onReset() {
      this.$refs.form.resetValidation()
      this.$emit('onReset', this.formAction)
    },
  },
}
</script>
